<template>
  <body class="ui_game_memory_wizard">
    <div class="row gamepage_header">
      <img class="gamepage_logo" src="static/images/logo-memory-wizard.png"/>
      <h1>{{ getTranslations.home_game_memory_wizard }}</h1>
      <p>{{ getTranslations.home_game_find_pairs }}</p>
    </div>
    <div class="row gamepage_timmer">
      <div class="game-timer__prog">
        <div class="game-timer__prog__inner " :style="progressBar"></div>
      </div>

    </div>
    <div class="row gamepage_game">

      <div class="col-4 gamepage_game_image " v-for="(icon, index) in personalizedData"
           @click="sendAnswer(icon.mwDisplayIndex)"
           :style="disableDiv"
           :key="icon.mwDisplayIndex" :ref="index+1">
        <div class="game_image_1" :style="showStyleBackground(icon.card.url)"></div>
      </div>

    </div>

    <component :is="modalForHomePage"></component>

  </body>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import TimeIsUp from '@/components/home/modals/TimeIsUp';
import PostGame from '@/components/home/modals/PostGame';
import WrongAnswer from '@/components/home/modals/WrongAnswer';
import webSocket from '@/common/webSocket';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin, GameMixin2 } from '@/common/mixins/game';
import modals from '../../../common/modals';

export default {
  name: 'memoryWizard',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin, GameMixin2],
  data() {
    return {
      progressBarWidth: 0.0,
      showedSpinModal: false,
      timeIsUp: false,
      showedModal: false,
      userLevel: 0,
      bonusPoints: 0,
      gamesEarned: 0,
      personalizedData: null,
      availableAnswers: [],
      secondsElapsed: 0,
      timer: null,
      timer1: null,
      indexToHideCards: 1,
      stompClient: null,
      subscription: null,
      buttonPushed: true,
    };
  },
  created() {
    console.log('in Game created hook');
    this.stompClient = webSocket.getGameStompClient();
    console.log('this.stompClient:', this.stompClient);
    this.initQuestionData();
    this.startSubscriptionChannel();
  },
  beforeDestroy() {
    console.log('in game\'s beforeDestroy hook');
    this.subscription.unsubscribe();
    this.resetGameState();
    this.stopTimer();
  },
  methods: {
    ...mapMutations('game', [
      'resetGameState',
      'resetPrizeData',
      'isGamePageFlow',
      'updateGameType',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    stompFailure(error) {
      console.log(error);
      window.location.reload();
    },
    hideCardsAfterConfigurableTimeOneByOne() {
      clearInterval(this.timer1);
      this.timer1 = setInterval(() => {
        this.$refs[this.indexToHideCards][0].classList.add('hide_card');
        this.indexToHideCards += 1;
        if (this.indexToHideCards > this.personalizedData.length) {
          clearInterval(this.timer1);
          this.buttonPushed = false;
          this.initAndStartTimer();
        }
      }, this.timeRoundIntro);
    },
    initAndStartTimer() {
      clearInterval(this.timer);
      this.onlyOneCicle = true;
      this.secondsElapsed = 0;
      /* eslint-disable */
      this.$nextTick(() => {
        this.timer = setInterval(() => {
          this.secondsElapsed += 1;
          this.progressBarWidth += (100 * 500) / this.roundTimeList[0];
          if ((this.secondsElapsed * 1000 / 2) === this.roundTimeList[0]) {
            this.progressBarWidth = 100.0;
            this.timeIsUp = true;
            clearInterval(this.timer);
          }
        }, 500);
      });
      /* eslint-enable */
    },
    stopTimer() {
      this.progressBarWidth = 0.0;
      clearInterval(this.timer);
    },
    initQuestionData() {
      console.log('initializing question data...');
      this.updateGameType('MW');
      this.isGamePageFlow(true);
      this.personalizedData = this.gameCardDTOS.slice(0).sort((a, b) => a.mwDisplayIndex - b.mwDisplayIndex);
      console.log('this.personalizedData:', this.personalizedData);
      this.normalTransition = false;
      this.timeIsUp = false;
      console.log('calling initAndStartTimer()...');
      this.hideCardsAfterConfigurableTimeOneByOne();
    },
    startSubscriptionChannel() {
      console.info(`Subscribing to channel: /topic/finishedGame/${this.gameID}`);
      this.subscription = this.stompClient.subscribe(`/topic/finishedGame/${this.gameID}`, (response) => {
        console.log('[Game] Inside ctaSelected response');
        // parse server response and return if any errors occur
        const responseBody = this.parseServerResponse(response.body);
        console.log(responseBody);
        const gameFinished = responseBody.gameDTO.won;
        if ((gameFinished === false)) { // time is up
          console.log('Time is up. Display Pop Up');
          this.storeModalForHomePage(TimeIsUp);
          this.normalTransition = true;
          modals.showHideModalForGameNotificationPage(this);
        }
      });
    },
    sendAnswer(answerIndex) {
      console.log('--> inside sendAnswer....');
      console.log('Card Index:', answerIndex);
      if (this.$refs[answerIndex][0].classList.contains('success_card')) {
        console.log('--> Card already matched....');
      } else {
        console.log('--> Card has not matched yet....');
        this.buttonPushed = true;
        this.$refs[answerIndex][0].classList.remove('fail_card');
        this.$refs[answerIndex][0].classList.add('show_card');
        // eslint-disable-next-line
        $("#container").html("");
        console.log('sending player answer');
        this.$axios({
          url: `api/sendAnswer?gameId=${this.gameID}&answerIndex=${answerIndex}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          console.log('inside sendAnswer');
          this.buttonPushed = false;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            const responseData = response.data.data;
            if (responseData.status === 'FAILED') {
              this.hideCardsOnIndexes(responseData.firstKey, responseData.secondKey);
            } else if (responseData.status === 'CORRECT') {
              this.successAnimationForIndexes(responseData.firstKey, responseData.secondKey);
            } else if (responseData.status === 'USER_WON') {
              console.log('User made to complete game');
              this.storeTIPostGameData(responseData);
              this.storeModalForHomePage(PostGame);
              this.normalTransition = true;
              modals.showHideModalForGameNotificationPage(this);
            } else if (responseData.status === 'MAX_ATTEMPTS_REACHED') {
              console.log('User reached max tries game');
              this.storeModalForHomePage(WrongAnswer);
              this.normalTransition = true;
              modals.showHideModalForGameNotificationPage(this);
            }
          }
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },
    hideCardsOnIndexes(lastChoice, firstChoice) {
      this.$refs[lastChoice][0].classList.remove('show_card');
      this.$refs[firstChoice][0].classList.remove('show_card');
      this.$refs[lastChoice][0].classList.add('fail_card');
      this.$refs[firstChoice][0].classList.add('fail_card');
    },
    successAnimationForIndexes(lastChoice, firstChoice) {
      // if response correct
      this.$refs[lastChoice][0].classList.add('success_card');
      this.$refs[firstChoice][0].classList.add('success_card');
      setTimeout(() => {
        this.$refs[lastChoice][0].classList.add('success_animation');
      }, this.secForMatchedCards);
    },
    updateNormalTransitionAndStartNewGame() {
      console.log('New Game button of post game pop up clicked');
      this.normalTransition = true;
      this.$router.push('/searchingOpponent');
    },
    showStyleBackground(url) {
      // eslint-disable-next-line
      return 'background-image:url(' + url.toString() + ')';
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('common', [
      'timeRoundIntro',
      'roundTimeList',
      'secForMatchedCards',
      'modalForHomePage',
    ]),
    ...mapState('game', [
      'gameCardDTOS',
      'spinWheelInfo',
      'gameID',
      'gameType',
      'playersDetails',
      'userLeveledUp',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    progressBar() {
      return {
        width: `${this.progressBarWidth}%`,
      };
    },
    disableDiv() {
      return (!this.timeIsUp && !this.buttonPushed) ? 'cursor:pointer' : 'pointer-events:none';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/MemoryWizard.vue